module.exports = __webpack_public_path__ + "img/00001.eaa74085.webp";